<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.03.07</b> - Shop inventory balance; item drop quality</p>
    <div class="ml-5 pb-4 text-violet-600">
      <div class="font-bold mt-2">New Features</div>
      <ul class="ml-4 list-disc">
        <li>Added a second shelf to the Shop, increasing total items available from 7 to 14</li>
        <li>Shop now tracks and displays which items have been sold out</li>
      </ul>

      <div class="font-bold mt-2">Gameplay & Balance Changes</div>
      <ul class="ml-4 list-disc">
        <li>Lowered Shop prices for most items</li>
        <li>Added small chance for Caverns drops and PvP reward items to be very high quality</li>
        <li>Poison Weapon ability can no longer target enemies without weapons</li>
      </ul>

      <div class="font-bold mt-2">Battle AI</div>
      <ul class="ml-4 list-disc">
        <li>
          Added consideration for Adrenaline & Mystic Focus when determining whether an ability can
          be used
        </li>
        <li>Fixed a bug causing Fumigate not to be used in certain situations when it should</li>
      </ul>

      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>Fixed several Edit Hero screen bugs</li>
        <li>Fixed Vampiric weapon proccing when target dies</li>
      </ul>
    </div>
  </div>
</template>
